import styled from 'styled-components';
import { Button as BsButton } from 'react-bootstrap';

import { WHITE_COLOR } from 'containers/App/constants';

export default styled(BsButton)`
  ${props => {
    let baseState = '&';
    let hoverState = '&:hover, &:active, &:active:focus';

    const nonSolidStyles = `
      border: none;
      background-color: ${WHITE_COLOR} !important;
      border: 2px solid ${props.color} !important;
      color: ${props.color} !important;
      font-weight: 500 !important;
    `;

    const solidStyles = `
      border: none;
      background-color: ${WHITE_COLOR};
      border: 2px solid ${props.color} !important;
      color: ${WHITE_COLOR} !important;
      background-color: ${props.color} !important;
      font-weight: 500;
    `;

    return `
        ${baseState} {
          ${props.inverted !== 'true' ? nonSolidStyles : solidStyles}
        }
        ${
          props.disableHoverEffect === 'true'
            ? ''
            : `
            ${hoverState} {
              ${props.inverted !== 'true' ? solidStyles : nonSolidStyles}
            }
            `
        }
      `;
  }}
`;
